<template>
	<section class="evaluation-questions-section">
		<div class="evaluation-questions-section--row" v-for="(skill, index) in skills" :key="index">
			<div
				class="evaluation-questions-section--row__title tw-px-6 tw-py-4 tw-flex tw-justify-between tw-items-center"
			>
				<h2 class="tw-text-app-color-font ">{{ skill.name }}</h2>
				<p-button
					v-if="(skill.selectedQuestions || []).length < lastStepConfig.maxSelectedQuestions"
					type="primary"
					roundedLevel="rounded"
					@click="handleAddQuestion(skill)"
				>
					+ Agregar Preguntas
				</p-button>
			</div>
			<evaluation-question-sortable-list
				:questions="skill.selectedQuestions || []"
				:questions-type="questionsType"
				@removeClicked="handleRemoveQuestions($event, skill)"
				@onSortedQuestionsChange="handleSortedQuestionsList($event, skill)"
			/>
		</div>
		<evaluation-select-question-dialog
			:questions="pathOr([], ['selectedLevel', 'questions'], focusedSkill)"
			:selected-questions="pathOr([], ['selectedQuestions'], focusedSkill)"
			:questions-type="questionsType"
			ref="evaluationSelectQuestionDialog"
			@onQuestionSelected="handleOnQuestionSelected($event)"
		></evaluation-select-question-dialog>
	</section>
</template>

<script>
import { append, assoc, findIndex, pathOr, propEq } from 'ramda';
import PButton from '../../../../shared/components/ui/p-button';
import CloseIcon from '../../../../shared/components/icons/close-icon';
import PDragHandle from '../../../../shared/components/ui/p-drag-handler';
import EvaluationQuestionSortableList from './evaluation-question-sortable-list';
import EvaluationSelectQuestionDialog from './evaluation-select-question-dialog';
import { removeElementInList } from '../../../../shared/utils/listElements';

export default {
	name: 'EvaluationQuestionsSection',
	props: {
		skills: {
			default: [],
		},
		lastStepConfig: {
			default: () => ({}),
		},
		questionsType: {
			default: () => ({}),
		},
	},
	data() {
		return {
			focusedSkill: {},
		};
	},
	components: {
		EvaluationSelectQuestionDialog,
		EvaluationQuestionSortableList,
		PDragHandle,
		CloseIcon,
		PButton,
	},
	methods: {
		pathOr,
		handleAddQuestion(skill) {
			this.focusedSkill = skill;
			this.$refs.evaluationSelectQuestionDialog.open();
		},
		handleOnQuestionSelected(selectedQuestion) {
			const foundIndex = findIndex(
				propEq('id', selectedQuestion.id),
				this.focusedSkill.selectedQuestions || [],
			);
			if (foundIndex > -1) return;
			const newSelectedQuestions = { ...selectedQuestion };
			newSelectedQuestions.percentageKpi = this.focusedSkill.percentageKpi || 0;
			this.focusedSkill.selectedQuestions = append(
				newSelectedQuestions,
				this.focusedSkill.selectedQuestions,
			);
			this.$emit('onSkillUpdate', this.focusedSkill);
		},
		handleRemoveQuestions(selectedQuestion, skill) {
			const updatedSelectedQuestions = removeElementInList(
				selectedQuestion,
				skill.selectedQuestions,
			);
			const updatedSkill = assoc('selectedQuestions', updatedSelectedQuestions, skill);
			this.$emit('onSkillUpdate', updatedSkill);
		},
		handleSortedQuestionsList(updatedQuestions, skill) {
			const updatedSkill = assoc('selectedQuestions', updatedQuestions, skill);
			this.$emit('onSkillUpdate', updatedSkill);
		},
	},
};
</script>

<style scoped lang="scss">
.evaluation-questions-section {
	height: 50vh;
	overflow: auto;
	&--row {
		&__title {
			background-color: var(--app-color-gray-white);
			border-bottom: 1px solid var(--app-color-gray);
			border-top: 1px solid var(--app-color-gray);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/third-step/components/evaluation-questions-section.vue